const USE_SSO = process.env.REACT_APP_USE_SSO !== 'false'

const KEY_ACTIVITY = process.env.REACT_APP_KEY_ACTIVITY === 'true'

const ACTIVITY_GROUP = process.env.REACT_APP_ACTIVITY_GROUP === 'true'

const ACTIVITY_REORDER = process.env.REACT_APP_ACTIVITY_REORDER === 'true'

export { USE_SSO, KEY_ACTIVITY, ACTIVITY_GROUP, ACTIVITY_REORDER }
